module.exports = __webpack_public_path__ + "img/c_icon.d7a4c840.png";